import React, { useEffect, useState } from 'react'
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Grid2 from '@mui/material/Unstable_Grid2';
import { Box, Button, FormControl, InputLabel, MenuItem, Select, TextField, inputClasses, inputLabelClasses } from '@mui/material';
import { Col, Row } from 'react-bootstrap';
import Home from '../home/Home';
import FundRqst_service from '../../Services/FundRqst_service';
import Snackbar from '../Snacbar'
import { getUserId } from '../Utils/Common';
import FileSaver from 'file-saver';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from "react-router";
import { ToggleButton } from '@mui/material';

const CssTextField = styled(TextField)(`
  .${inputClasses.root} {
    height:35px;
  }
  .${inputLabelClasses.root} {
    font-family: Times New Roman;
    font-weight:bold;
    &.${inputLabelClasses.focused} {
      color: primary;
    }
  }
`);
const Csscontrol = styled(FormControl)({
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
        }
    },
});
const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    backgroundColor: 'white',
    height: '100%',
    border: '1px solid black'
}));
const Item1 = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1),
    // textAlign: 'center',
    color: theme.palette.text.secondary,
    backgroundColor: 'white',
    height: '100%',
    border: '1px solid black'
}));
const Item2 = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'right',
    color: theme.palette.text.secondary,
    backgroundColor: 'white',
    height: '100%',
    border: '1px solid black'
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        color: theme.palette.common.black,
        backgroundColor: 'rgb(61, 195, 177)',
        padding: theme.spacing(0.5),
        fontFamily: 'Times New Roman',
        fontWeight: 'bold',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        fontFamily: 'Times New Roman',

    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: 'white',
    },
}));


function FundFristLvlVerification() {
    const [message, setMessage] = useState('');
    const [open, setOpen] = useState(false);
    const [severit, setseverit] = useState('');

    const [fundstatusdrp, setfundstatusdrp] = useState([]);
    const [Vendordrp, setVendordrp] = useState([]);
    const [PaymentModedrp, setPaymentModedrp] = useState([]);
    const [status, setstatus] = useState('')
    const [FirstVeriDetails, setFirstVeriDetails] = useState([]);
    const [FirstVeriDetails2, setFirstVeriDetails2] = useState([]);
    const [FirstVeriDetails3, setFirstVeriDetails3] = useState([]);
    const [FirstVeriDetails4, setFirstVeriDetails4] = useState([]);
    const [FirstVeriDetails5, setFirstVeriDetails5] = useState([]);
    // const [paymentcopydetails, setpaymentcopydetails] = useState([]);

    //
    const [FilteredDetails, setFilteredDetails] = useState([])
    const [FilteredDetails2, setFilteredDetails2] = useState([])

    const [Fund1stLvlvrfyvalues, setFund1stLvlvrfyvalues] = useState({
        cmid: '',
        purpose_pmtid: '',
        purpose_reqpurid: '',
        purposeSummary_id: '',

        fundstatus: '',
        jobNo: '',
        vendorType: '',
        Reqamt: '',
        Aprvlamt: '',
        firstLvlAmt: '',
        paymentMode: '',
        firstLvlRmks: '',
    })


    ///Handle Change=>>
    const firstLvlFundStatusHandleChange = (e) => {
        if (e.target.value === 'JOB') {
            setstatus(1)
        } else if (e.target.value === 'VENDOR') {
            setstatus(2)
        } else if (e.target.value === 'MISCELLANEOUS') {
            setstatus(3)
        } else if (e.target.value === 'CLIENT') {
            setstatus(4)
        }
        setFirstVeriDetails([])
        setFirstVeriDetails2([])
        setFilteredDetails([])
        setFirstVeriDetails4([])
        setFirstVeriDetails2([])
        setFirstVeriDetails3([])
        setFund1stLvlvrfyvalues({
            ...Fund1stLvlvrfyvalues, fundstatus: e.target.value, cmid: '', purpose_pmtid: '', purpose_reqpurid: '', purposeSummary_id: '', jobNo: '',
            Aprvlamt: '', Reqamt: '', firstLvlAmt: '', paymentMode: '', firstLvlRmks: '', vendorType: '',
        })
        var consignmentNumber = '';
        if (e.target.value === 'JOB') {
            if (Fund1stLvlvrfyvalues.jobNo === '') {
                consignmentNumber = '-1';
            } else {
                consignmentNumber = Fund1stLvlvrfyvalues.jobNo;
            }
        }
        else if (e.target.value !== 'JOB') {
            if (Fund1stLvlvrfyvalues.vendorType === '') {
                consignmentNumber = '-1';
            } else {
                consignmentNumber = Fund1stLvlvrfyvalues.vendorType;
            }
        }
        let details = { consignmentNumber: consignmentNumber, status: '3', requestStatus: e.target.value }
        FundRqst_service.getPaymentNonJobNo(details).then(res => { setFirstVeriDetails(res.data); setFilteredDetails(res.data) });

        let details2 = { consignmentNumber: consignmentNumber, status: '3', requestStatus: e.target.value }
        FundRqst_service.getPaymentJobNo(details2).then(res => { setFirstVeriDetails4(res.data); setFilteredDetails2(res.data) });

        FundRqst_service.getBillPaymentType().then(res => { setPaymentModedrp(res.data); });

        if (e.target.value === 'JOB') {
            SetVendorHidden(true)
            SetJobHidden(false)
            setdesignHidden(false)
            settablehidden(false)
            setsearchbtnhidden(false)
        }
        else if (e.target.value === 'VENDOR' || e.target.value === 'MISCELLANEOUS' || e.target.value === 'CLIENT') {
            FundRqst_service.getVendorType(e.target.value).then(res => {
                setVendordrp(res.data)
            });
            SetVendorHidden(false)
            SetJobHidden(true)
            setdesignHidden(false)
            settablehidden(false)
            setsearchbtnhidden(true)

        }
        else if (e.target.value === "") {
            SetVendorHidden(true)
            SetJobHidden(true)
            setdesignHidden(true)
            settablehidden(true)
            setsearchbtnhidden(true)
        }
    }
    const firstLvl_jobNoHandleChange = (e) => {
        setFund1stLvlvrfyvalues({ ...Fund1stLvlvrfyvalues, jobNo: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const firstLvl_vendortypHandleChange = (e) => {
        setFund1stLvlvrfyvalues({ ...Fund1stLvlvrfyvalues, vendorType: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') });
        let details = { consignmentNumber: e.target.value, status: '3', requestStatus: Fund1stLvlvrfyvalues.fundstatus }
        FundRqst_service.getPaymentNonJobNo(details).then(res => { setFirstVeriDetails(res.data); setFilteredDetails(res.data) });

        let details2 = { consignmentNumber: e.target.value, status: '3', requestStatus: Fund1stLvlvrfyvalues.fundstatus }
        FundRqst_service.getPaymentJobNo(details2).then(res => { setFirstVeriDetails4(res.data); setFilteredDetails2(res.data) });
    }
    const firstLvl_amtHandleChange = (e) => {
        setFund1stLvlvrfyvalues({ ...Fund1stLvlvrfyvalues, firstLvlAmt: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const firstLvl_paymntmdHandleChange = (e) => {
        setFund1stLvlvrfyvalues({ ...Fund1stLvlvrfyvalues, paymentMode: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const firstLvl_RmksHandleChange = (e) => {
        setFund1stLvlvrfyvalues({ ...Fund1stLvlvrfyvalues, firstLvlRmks: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const FundStsName = () => {
        if (status === 1) {
            return 'Job No';
        }
        else if (status === 2) {
            return 'VENDOR';
        }
        else if (status === 3) {
            return 'MISCELLANEOUS';
        }
        else if (status === 4) {
            return 'CLIENT';
        }
    }
    //keydown
    const jobkeydown = (e) => {
        if (e.key === 'Enter') {
            Jobserachbtn()
        }
    }
    const firstLvlkeydown = (e) => {
        if (e.key === 'Enter') {
            document.getElementById('paymentmode').focus()
        }
    }
    const paymentMdkeydown = (e) => {
        if (e.key === 'Enter') {
            document.getElementById('rmks').focus()
        }
    }
    ///hidden
    const [designHidden, setdesignHidden] = useState(true);
    const [tablehidden, settablehidden] = useState(true);
    const [VendorHidden, SetVendorHidden] = useState(true);
    const [JobHidden, SetJobHidden] = useState(false);
    const [searchbtnhidden, setsearchbtnhidden] = useState(true);

    ///disableButtons
    const [verifyDis, setverifyDis] = useState(true);
    const [UpdateDis, setUpdateDis] = useState(true);
    const [NonverifyDis, setNonverifyDis] = useState(true);
    const [DwnlddRqsrDis, setDwnlddRqsrDis] = useState(true);

    ///processing
    const [verifyPros, setverifyPros] = useState(false)
    const [updatePros, setupdatePros] = useState(false)
    const [nanverifyPros, setnanverifyPros] = useState(false)
    const [dwnldRqstCpyPros, setdwnldRqstCpyPros] = useState(false)
    const [refreshPros, setrefreshPros] = useState(false)
    ////resetall====>
    const ResetAll = () => {
        setFund1stLvlvrfyvalues({
            ...Fund1stLvlvrfyvalues, cmid: '', purpose_pmtid: '', purpose_reqpurid: '', purposeSummary_id: '', jobNo: '',
            Aprvlamt: '', Reqamt: '', firstLvlAmt: '', paymentMode: '', firstLvlRmks: '',
        })
        ResetBtns();
        setFilteredDetails([])
        setFilteredDetails2([])
        setFirstVeriDetails([])
        setFirstVeriDetails2([])
        setFirstVeriDetails3([])
        setFirstVeriDetails4([])
        setFirstVeriDetails5([])
        setverifyPros(false)
        setupdatePros(false)
        setnanverifyPros(false)
        setdwnldRqstCpyPros(false)
        setrefreshPros(false)
        Getpaymentjob_nonjob_no();
    }
    ///////ResetBtns=====>
    const ResetBtns = () => {
        setverifyDis(true)
        setUpdateDis(true)
        setNonverifyDis(true)
        setDwnlddRqsrDis(true)
    }
    ////Validation=============>
    const FirstLevelValidation = () => {
        if (Fund1stLvlvrfyvalues.firstLvlAmt !== '') {
            if (Fund1stLvlvrfyvalues.paymentMode !== '') {
                return true;
            } else {
                setMessage('Please Select Payment Mode ,Warning ..!!');
                setseverit('warning');
                setOpen(true);
                document.getElementById('paymentmode').focus();
            }
        } else {
            setMessage('Please Enter Payment Request Amount ,Warning ..!!');
            setseverit('warning');
            setOpen(true);
            document.getElementById('1stlvlamt').focus();
        }
        return false;
    }

    ///////SearchBtn==========>
    const Jobserachbtn = () => {
        setverifyDis(true)
        setUpdateDis(true)
        setNonverifyDis(true)
        setDwnlddRqsrDis(true)
        Getpaymentjob_nonjob_no();
        setFund1stLvlvrfyvalues({ ...Fund1stLvlvrfyvalues, Aprvlamt: '', Reqamt: '', firstLvlAmt: '', paymentMode: '', firstLvlRmks: '', })
        setFirstVeriDetails3([]);
        setFirstVeriDetails2([]);
    }
    const [selected, setSelected] = useState([]);
    const [selected1, setSelected1] = useState([]);
    /////
    const getnonpurpose = (trns) => {
        const selectedIndex = selected.indexOf(trns.consignmentNumber);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = (selected, trns.consignmentNumber);
        }
        setSelected(newSelected);
        setFirstVeriDetails2([])
        setFirstVeriDetails5([])
        setverifyDis(true);
        setUpdateDis(true);
        setNonverifyDis(true);
        setDwnlddRqsrDis(true);
        setFund1stLvlvrfyvalues({
            ...Fund1stLvlvrfyvalues, cmid: trns.cmId, purpose_pmtid: '', purpose_reqpurid: '', Aprvlamt: '', Reqamt: '', firstLvlAmt: '',
            paymentMode: '', firstLvlRmks: '',
        })
        setFirstVeriDetails3([]);

        let details = { cmId: trns.cmId, status: '3', requestStatus: Fund1stLvlvrfyvalues.fundstatus }
        FundRqst_service.getPaymentReqPurpose(details).then(res => {
            setFirstVeriDetails2(res.data);
        });
        let details2 = { paymentId: trns.cmId, requestStatus: Fund1stLvlvrfyvalues.fundstatus }
        FundRqst_service.getPaymentSummaryDetails(details2).then(res => {
            setFirstVeriDetails5(res.data);
        })
    }
    const isSelected = (name) => selected.indexOf(name) !== -1;
    ///
    const nonverifypurpose = (trns) => {
        const selectedIndex = selected1.indexOf(trns.reqAmount);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = (selected1, trns.reqAmount);
        }
        setSelected1(newSelected);
        setFirstVeriDetails3([])
        setverifyDis(false);
        setUpdateDis(true);
        setNonverifyDis(true);
        setDwnlddRqsrDis(false);

        getFirtLvlvrfyAssign(trns.paymentId, trns.reqPurpose, 1)

        // let details = { cmId:Fund1stLvlvrfyvalues.cmid, reqPurpose: trns.reqPurpose, status: '1' }
        // FundRqst_service.getPaymentCopy(details).then(res => {
        //     setpaymentcopydetails(res.data);
        // })
    }
    const isNonReqItemSelected = (name) => selected1.indexOf(name) !== -1;
    ///
    const verifypurpose = (trns) => {
        const selectedIndex = selected1.indexOf(trns.reqAmount);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = (selected1, trns.reqAmount);
        }
        setSelected1(newSelected);
        setFirstVeriDetails2([])
        setverifyDis(true);
        setUpdateDis(false);
        setNonverifyDis(false);
        setDwnlddRqsrDis(false);

        getFirtLvlvrfyAssign(trns.paymentId, trns.reqPurpose, 2)

        // let details = { cmId: Fund1stLvlvrfyvalues.cmid, reqPurpose: trns.reqPurpose, status: '1' }
        // FundRqst_service.getPaymentCopy(details).then(res => {
        //     setpaymentcopydetails(res.data);
        // })
    }
    const isReqItemSelected = (name) => selected1.indexOf(name) !== -1;
    ///
    const getpurpose = (trns) => {
        const selectedIndex = selected.indexOf(trns.consignmentNumber);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = (selected, trns.consignmentNumber);
        }
        setSelected(newSelected);
        setFirstVeriDetails3([])
        setFirstVeriDetails5([])
        setverifyDis(true);
        setUpdateDis(true);
        setNonverifyDis(true);
        setDwnlddRqsrDis(true);
        setFund1stLvlvrfyvalues({
            ...Fund1stLvlvrfyvalues, cmid: trns.cmId, purpose_pmtid: '', purpose_reqpurid: '', Aprvlamt: '', Reqamt: '', firstLvlAmt: '',
            paymentMode: '', firstLvlRmks: '',
        })
        setFirstVeriDetails2([]);

        let details = { cmId: trns.cmId, status: '7', requestStatus: Fund1stLvlvrfyvalues.fundstatus }
        FundRqst_service.getPaymentReqPurpose(details).then(res => {
            setFirstVeriDetails3(res.data);
        });
        let details2 = { paymentId: trns.cmId, requestStatus: Fund1stLvlvrfyvalues.fundstatus }
        FundRqst_service.getPaymentSummaryDetails(details2).then(res => {
            setFirstVeriDetails5(res.data);
        })
    }
    const isReqjobSelected = (name) => selected.indexOf(name) !== -1;
    ///
    const FundStatusDropdown = async () => {
        FundRqst_service.getFundStatus().then(res => {
            setfundstatusdrp(res.data)
        })
    }
    ///////
    const getFirtLvlvrfyAssign = (val, reqPurpose, val2) => {
        let details = { paymentId: val }
        FundRqst_service.getPaymentDetails(details).then(res => {
            const data = res.data;
            const details = data.map((item) => item);
            var firstMode, txt_amount, appRemarks = '';
            if (val2 === 1) {
                txt_amount = details[0].approvalAmunt
            } else {
                txt_amount = details[0].firstLevelAmount
            }
            if (details[0].appMode === null || details[0].appMode === '' || !details[0].appMode) {
                firstMode = '';
            } else {
                firstMode = details[0].appMode;
            }
            if (details[0].appRemarks === null || details[0].appRemarks === '' || !details[0].appRemarks) {
                appRemarks = '';
            } else {
                appRemarks = details[0].appRemarks;
            }
            setFund1stLvlvrfyvalues({
                ...Fund1stLvlvrfyvalues, paymentMode: firstMode, firstLvlAmt: txt_amount, Reqamt: details[0].reqAmount,
                firstLvlRmks: appRemarks,
                Aprvlamt: details[0].approvalAmunt, purpose_pmtid: val, purpose_reqpurid: reqPurpose,
            })
        }).catch(error => {
            setMessage(error.message);
            setseverit('error');
            setOpen(true);
        })
    }
    ///////
    const Getpaymentjob_nonjob_no = () => {
        var consignmentNumber = '';
        if (Fund1stLvlvrfyvalues.fundstatus === 'JOB') {
            if (Fund1stLvlvrfyvalues.jobNo === '') {
                consignmentNumber = '-1';
            } else {
                consignmentNumber = Fund1stLvlvrfyvalues.jobNo;
            }
        }
        else if (Fund1stLvlvrfyvalues.fundstatus !== 'JOB') {
            if (Fund1stLvlvrfyvalues.vendorType === '') {
                consignmentNumber = '-1';
            } else {
                consignmentNumber = Fund1stLvlvrfyvalues.vendorType;
            }
        }
        let details = { consignmentNumber: consignmentNumber, status: '3', requestStatus: Fund1stLvlvrfyvalues.fundstatus }
        FundRqst_service.getPaymentNonJobNo(details).then(res => { setFirstVeriDetails(res.data); setFilteredDetails(res.data) });

        let details2 = { consignmentNumber: consignmentNumber, status: '3', requestStatus: Fund1stLvlvrfyvalues.fundstatus }
        FundRqst_service.getPaymentJobNo(details2).then(res => { setFirstVeriDetails4(res.data); setFilteredDetails2(res.data) });

    }

    ///Buttons Functions==========>
    const verift_update_operations = () => {
        if (FirstLevelValidation() === true) {
            setverifyPros(true)
            setupdatePros(true)
            let details = {
                cmId: Fund1stLvlvrfyvalues.purpose_pmtid, reqAmount: null, reqPurpose: null, reqPaidTo: null, reqDate: null, reqBy: null, approvalAmunt: null,
                approvalDate: null, approvalBy: null, firstLevelAmount: Fund1stLvlvrfyvalues.firstLvlAmt, firstLevelDate: null, firstVeryBy: getUserId(),
                secondLevelAmount: null, secondLevelDate: null, secondVeryBy: null, allocatedAmount: null, allocatedMode: Fund1stLvlvrfyvalues.paymentMode,
                allocatedVoucherNo: null, allocatedVoucherType: null, allocatedVocherCopy: null, allocatedPrintedBy: null, allocatedDate: null, allocatedBy: null,
                status: '3', remarks: Fund1stLvlvrfyvalues.firstLvlRmks, referenceNo: null, bankName: null, accountNo: null, ifsc: null, benName: null,
                gstinPayee: null, requestStatus: Fund1stLvlvrfyvalues.fundstatus, refundStatus: null,
            }
            FundRqst_service.updatePaymentDetails(details).then(res => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setMessage('Verified Successfully');
                    setseverit('success');
                    setOpen(true);
                    ResetAll();
                } else {
                    setMessage('Verification Failed ' + message.toString());
                    setseverit('error');
                    setOpen(true);
                }
            }).catch(error => {
                setMessage('Verification Failed ' + error.message);
                setseverit('error')
                setOpen(true);
            })
            setverifyPros(false)
            setupdatePros(false)
        }
    }
    const verifBtn = () => {
        setverifyPros(true)
        verift_update_operations()
        setverifyPros(false)
    }
    const updateBtn = () => {
        setupdatePros(true)
        verift_update_operations()
        setupdatePros(false)
    }
    const NonverifyBtn = () => {
        setnanverifyPros(true)
        let details = {
            cmId: Fund1stLvlvrfyvalues.cmid, paymentId: Fund1stLvlvrfyvalues.purpose_pmtid, status: '3',
            createdBy: getUserId(), requestStatus: Fund1stLvlvrfyvalues.purpose_reqpurid
        }
        FundRqst_service.updatePaymentStatus(details).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Non-Verified Successfully');
                setseverit('success');
                setOpen(true);
                ResetAll();
            } else {
                setMessage('Non-Verification Failed ,Warning ..!!' + message.toString());
                setseverit('error');
                setOpen(true);
                document.getElementById('1stlvlamt').focus();
            }
        }).catch(error => {
            setMessage('Verification Failed ' + error.message);
            setseverit('error');
            setOpen(true);
        })
        setnanverifyPros(false)
    }
    const saveimage = () => {
        setdwnldRqstCpyPros(true)
        // const lastresult = paymentcopydetails.map((item) => item);
        let details = { cmId: Fund1stLvlvrfyvalues.cmid, reqPurpose: Fund1stLvlvrfyvalues.purpose_reqpurid, status: '1' }
        FundRqst_service.getPaymentCopy(details).then(res => {
            const data = res.data;
            const detaill = data.map(node => node.docImage)
            // console.log('before saveAs '+JSON.stringify(detaill.toString()))
            // FileSaver.saveAs(`data:image/jpeg;base64,${detaill.toString()}`, Fund1stLvlvrfyvalues.cmid + "-" + Fund1stLvlvrfyvalues.purpose_reqpurid + ".jpg");
            const filedata = detaill.toString()
            const formates = filedata.split('/9j/4');
            //    console.log('ggg '+JSON.stringify(formates))
            if (formates[0] === '') {
                FileSaver.saveAs(`data:image/jpg;base64,${detaill.toString()}`, Fund1stLvlvrfyvalues.cmid + "-" + Fund1stLvlvrfyvalues.purpose_reqpurid + ".jpg");
            } else {
                const Pngformates = filedata.split('iVBORw0KGg');
                if (Pngformates[0] === '') {
                    FileSaver.saveAs(`data:image/jpg;base64,${detaill.toString()}`, Fund1stLvlvrfyvalues.cmid + "-" + Fund1stLvlvrfyvalues.purpose_reqpurid + ".jpg");
                } else {
                    FileSaver.saveAs(`data:application/pdf;base64,${detaill.toString()}`, Fund1stLvlvrfyvalues.cmid + "-" + Fund1stLvlvrfyvalues.purpose_reqpurid + ".pdf");
                }
            }

            setdwnldRqstCpyPros(false)
        }).catch(error => {
            setMessage('Insertion Failed! ,' + error.message)
            setseverit('error')
            setOpen(true)
            setdwnldRqstCpyPros(false)
        })
        // FileSaver.saveAs(lastresult[0].docImage, Fund1stLvlvrfyvalues.cmid + "-" + Fund1stLvlvrfyvalues.purpose_reqpurid + ".pdf")
        // dwnldRqstCpyPros(false)
    }
    const RefreshBtn = () => {
        setrefreshPros(true)
        setFund1stLvlvrfyvalues({
            ...Fund1stLvlvrfyvalues, cmid: '', purpose_pmtid: '', purpose_reqpurid: '',
            fundstatus: 'JOB', Aprvlamt: '', Reqamt: '', firstLvlAmt: '', paymentMode: '', firstLvlRmks: '', vendorType: '',
        })
        document.getElementById('fundstatus').focus();
        ResetBtns();
        Getpaymentjob_nonjob_no()
        setFilteredDetails([])
        setFilteredDetails2([])
        setFirstVeriDetails([])
        setFirstVeriDetails2([])
        setFirstVeriDetails3([])
        setFirstVeriDetails4([])
        setrefreshPros(false)
    }
    //table search
    const fundSrch = () => {
        return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
            onChange={(e) => { fundOnchange(e.target.value) }} />
    }
    const fundOnchange = (searchedVal) => {
        const filteredvalue = FirstVeriDetails.filter((trns) => {
            return trns.consignmentNumber.toString().toLowerCase().includes(searchedVal.toLowerCase())
        })
        if (filteredvalue.length > 1) {
            setFilteredDetails(FirstVeriDetails)
        } else {
            setFilteredDetails(filteredvalue)
        }
    }
    const fundSrch2 = () => {
        return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
            onChange={(e) => { fund2Onchange(e.target.value) }} />
    }
    const fund2Onchange = (searchedVal) => {
        const filteredvalue = FirstVeriDetails4.filter((trns) => {
            return trns.consignmentNumber.toString().toLowerCase().includes(searchedVal.toLowerCase())
        })
        if (filteredvalue.length > 1) {
            setFilteredDetails2(FirstVeriDetails4)
        } else {
            setFilteredDetails2(filteredvalue)
        }
    }
    useEffect(() => {
        FundStatusDropdown();
    }, []);

    const handleClose = () => {
        setOpen(false)
    }

    const navigate = useNavigate();
    const BackBotton = () => {
        navigate('/fundaprvl');
    }
    const ForwordBotton = () => {
        navigate('/fund2ndlvlvrfy');
    }
    return (
        <div>
            <Home />
            <Snackbar open={open} message={message} severity={severit} onClose={handleClose} />
            <div style={{ paddingLeft: '80px', transition: '1s', transitionDelay: 'revert-layer' }}>
                <Row>
                    <Col xs={1}><ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small">
                        <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px', marginLeft: '5px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton></Col>
                    <Col xs={10}></Col>
                    <Col xs={1} style={{ textAlign: 'end' }}> <ToggleButton onClick={ForwordBotton} className='headerstyleEND' size="small">
                        <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton>
                    </Col>
                </Row>
                <Grid2 container>
                    <Box style={{ width: '11.5%' }}>
                        <Item1>
                            {/* <ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small" >
                                <ArrowBackIosIcon fontSize='small' style={{ fontSize: '16px', marginLeft: '5px' }} /> </ToggleButton> */}
                            <lable style={{ fontSize: '10px', fontWeight: 'bold', color: 'red', marginLeft: '7px', fontFamily: 'Times New Roman' }}>NonFirst Level Job</lable>
                            <TableContainer sx={{ maxHeight: 300 }} className='scrollbarPrime'>
                                <Table stickyHeader className='table table-bordered'>
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell style={{ textAlign: 'center' }}>`{FundStsName()}</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow >
                                            <StyledTableCell style={{ textAlign: 'center' }}>{fundSrch()}</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {FilteredDetails.map((trns) => {
                                            const isItemSelected = isSelected(trns.consignmentNumber);
                                            return (
                                                <TableRow hover selected={isItemSelected} key={trns.consignmentNumber} onClick={() => getnonpurpose(trns)}>
                                                    <StyledTableCell style={{ textAlign: 'center', color: 'darkblue' }}>{trns.consignmentNumber}</StyledTableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Item1>
                    </Box>
                    <Box style={{ width: '20%' }}>
                        <Item>
                            <lable style={{ fontSize: '10px', fontWeight: 'bold', color: 'red', fontFamily: 'Times New Roman' }}>Non First Level Verify Purpose</lable>
                            <TableContainer sx={{ maxHeight: 300 }} className='scrollbarPrime'>
                                <Table stickyHeader className='table table-bordered'>
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell style={{ width: '10px', textAlign: 'center' }}>Sl</StyledTableCell>
                                            <StyledTableCell style={{ textAlign: 'center', width: '100px' }}>Description</StyledTableCell>
                                            <StyledTableCell style={{ width: '40px', textAlign: 'center' }}>Amount</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {FirstVeriDetails2.map((trns) => {
                                            const isItemSelected = isNonReqItemSelected(trns.reqAmount);
                                            return (
                                                <TableRow hover selected={isItemSelected} key={trns.reqAmount} onClick={() => nonverifypurpose(trns)}>
                                                    <StyledTableCell style={{ color: 'darkblue' }}>{trns.serialNumber}</StyledTableCell>
                                                    <StyledTableCell style={{ color: 'darkblue' }}>{trns.reqPurpose}</StyledTableCell>
                                                    <StyledTableCell style={{ color: 'darkblue' }}>{trns.reqAmount}</StyledTableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Item>
                    </Box>
                    <Box style={{ width: '37%' }}>
                        <Item>
                            <div style={{ color: 'red', fontWeight: 'bold', fontSize: '20px', marginTop: '2%', fontFamily: 'Times New Roman' }}><center>FUND FIRST LEVEL VERIFICATION</center></div>
                            <Csscontrol fullWidth size='small' style={{ width: '35%', marginTop: '4%' }}>
                                <InputLabel id="demo-select-small" style={{ fontFamily: 'Times New Roman', fontWeight: 'bold' }}>Fund Status</InputLabel>
                                <Select label="Fund Statusss" id='fundstatus' style={{ fontSize: '13px', fontFamily: 'Times New Roman', color: 'black', fontWeight: 'bold', textAlign: 'center', }} onChange={firstLvlFundStatusHandleChange} value={Fund1stLvlvrfyvalues.fundstatus}>
                                    <MenuItem></MenuItem>
                                    {fundstatusdrp.map(status => (
                                        <MenuItem value={status.requestStatus}>{status.requestStatus}</MenuItem>
                                    ))}
                                </Select>
                            </Csscontrol>

                            <CssTextField size='small' hidden={JobHidden} type={'number'} style={{ marginLeft: '2%', width: '35%', marginTop: '4%' }} label="Job No" variant="outlined"
                                sx={{ input: { fontFamily: 'Times New Roman', color: 'black', fontWeight: 'bold', textAlign: 'center', fontSize: '13px' } }} value={Fund1stLvlvrfyvalues.jobNo} onChange={firstLvl_jobNoHandleChange} onKeyDown={jobkeydown} />

                            <Button size='small' variant="contained" hidden={searchbtnhidden} color="primary" style={{ fontFamily: 'Times New Roman', marginTop: '4%', marginLeft: '1%' }} onClick={Jobserachbtn}>Search</Button>

                            <Csscontrol hidden={VendorHidden} fullWidth size='small' style={{ marginLeft: '2%', width: '35%', marginTop: '4%' }}
                                InputLabelProps={{ shrink: true, }}>
                                <InputLabel id="demo-select-small" style={{ fontFamily: 'Times New Roman', fontWeight: 'bold' }}>Vendor Type</InputLabel>
                                <Select label="Vendor Typeeee" style={{ fontSize: '13px', fontFamily: 'Times New Roman', color: 'black', fontWeight: 'bold', textAlign: 'center', }} native value={Fund1stLvlvrfyvalues.vendorType} onChange={firstLvl_vendortypHandleChange}>
                                    <option></option>
                                    {Vendordrp.map(trns => (
                                        <option value={trns.reqPaidTo}>{trns.reqPaidTo}</option>
                                    ))}
                                </Select>
                            </Csscontrol>

                            <div hidden={designHidden}>
                                <Row className='mt-4'>
                                    <Col xs={4}>
                                        <InputLabel style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'black' }}>Request Amount :</InputLabel>
                                    </Col>
                                    <Col xs={2} style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'Red' }}>{Fund1stLvlvrfyvalues.Reqamt}</Col>
                                    <Col xs={4}>
                                        <InputLabel style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'black' }} >Approval Amount :</InputLabel>
                                    </Col>
                                    <Col xs={2} style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'Red' }}>{Fund1stLvlvrfyvalues.Aprvlamt}</Col>
                                </Row>

                                <Row className='mt-4'>
                                    <Col sm={1}></Col>
                                    <Col sm={5}>
                                        <CssTextField size='small' type={'number'} label="1st Lvl Vr.Amt" variant="outlined" id='1stlvlamt' sx={{ input: { fontSize: '13px', fontWeight: 'bold' } }}
                                            style={{ width: '100%' }} value={Fund1stLvlvrfyvalues.firstLvlAmt} onChange={firstLvl_amtHandleChange} onKeyDown={firstLvlkeydown} required />
                                    </Col>
                                    <Col sm={5}>
                                        <Csscontrol fullWidth size='small' onKeyDown={paymentMdkeydown} required
                                            InputLabelProps={{ shrink: true, }}>
                                            <InputLabel id="demo-select-small" style={{ fontFamily: 'Times New Roman', fontWeight: 'bold' }}>Payment Mode</InputLabel>
                                            <Select label="Payment Modeee" style={{ fontSize: '13px', fontFamily: 'Times New Roman', color: 'black', fontWeight: 'bold', textAlign: 'center', width: '100%' }} InputLabelProps={{ shrink: true, }} id='paymentmode'
                                                value={Fund1stLvlvrfyvalues.paymentMode} native onChange={firstLvl_paymntmdHandleChange}>
                                                <option></option>
                                                {PaymentModedrp.map(trns => (
                                                    <option value={trns.paymentType}>{trns.paymentType}</option>
                                                ))}
                                            </Select>
                                        </Csscontrol>
                                    </Col>
                                    <Col sm={1}></Col>
                                </Row>

                                <CssTextField size='small' id='rmks' style={{ marginTop: '3.5%' }} sx={{ input: { fontFamily: 'Times New Roman', color: 'black', fontWeight: 'bold', textAlign: 'center', fontSize: '13px' } }} label="1st Lvl Vr.Remarks" variant="outlined"
                                    value={Fund1stLvlvrfyvalues.firstLvlRmks} onChange={firstLvl_RmksHandleChange} />
                            </div>
                        </Item>
                    </Box>
                    <Box style={{ width: '20%' }}>
                        <Item>
                            <lable style={{ fontSize: '10px', fontWeight: 'bold', color: 'red', fontFamily: 'Times New Roman', }}>First Level Verify Purpose</lable>
                            <TableContainer className='scrollbarPrime' sx={{ maxHeight: 300 }}>
                                <Table stickyHeader className='table table-bordered'>
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell style={{ width: '10px', textAlign: 'center' }}>Sl</StyledTableCell>
                                            <StyledTableCell style={{ textAlign: 'center' }} >Description</StyledTableCell>
                                            <StyledTableCell style={{ width: '40px', textAlign: 'center' }}>Amount</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {FirstVeriDetails3.map((trns) => {
                                            const isItemSelected = isReqItemSelected(trns.reqAmount);
                                            return (
                                                <TableRow hover selected={isItemSelected} key={trns.reqPurpose} onClick={() => verifypurpose(trns)}>
                                                    <StyledTableCell style={{ color: 'darkblue' }}>{trns.serialNumber}</StyledTableCell>
                                                    <StyledTableCell style={{ color: 'darkblue' }}>{trns.reqPurpose}</StyledTableCell>
                                                    <StyledTableCell style={{ color: 'darkblue' }}>{trns.reqAmount}</StyledTableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Item>
                    </Box>
                    <Box style={{ width: '11.5%' }}>
                        <Item2>
                            <lable style={{ fontSize: '10px', fontWeight: 'bold', color: 'red', marginRight: '2px', fontFamily: 'Times New Roman', }}>FirstLevelVerifyJob</lable>
                            {/* <ToggleButton onClick={ForwordBotton} size="small" className='headerstyleEND'>
                                <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px' }} /> </ToggleButton> */}
                            <TableContainer sx={{ maxHeight: 300 }} className='scrollbarPrime'>
                                <Table stickyHeader className='table table-bordered'>
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell style={{ textAlign: 'center', }}>`{FundStsName()}</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow >
                                            <StyledTableCell style={{ textAlign: 'center' }}>{fundSrch2()}</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {FilteredDetails2.map((trns) => {
                                            const isItemSelected = isReqjobSelected(trns.consignmentNumber);
                                            return (
                                                <TableRow hover selected={isItemSelected} key={trns.consignmentNumber} onClick={() => getpurpose(trns)} >
                                                    <StyledTableCell style={{ textAlign: 'center', color: 'darkblue' }}>{trns.consignmentNumber}</StyledTableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Item2>
                    </Box>
                </Grid2>
                <center hidden={designHidden}><div className='mt-2 mb-1 form-inline'>
                    {/* hhh.. */}
                    <Button size='small' style={{ fontFamily: 'Times New Roman' }} variant="contained" color="primary" className='mt-1' disabled={verifyDis} onClick={verifBtn}>{verifyPros ? 'processing...' : 'VERIFY'}</Button>{' '}
                    <Button size='small' style={{ fontFamily: 'Times New Roman' }} variant="contained" className='mt-1' color="primary" disabled={UpdateDis} onClick={updateBtn}>{updatePros ? 'processing...' : 'UPDATE'}</Button>{' '}
                    <Button size='small' style={{ fontFamily: 'Times New Roman' }} variant="contained" className='mt-1' color="primary" disabled={NonverifyDis} onClick={NonverifyBtn}>{nanverifyPros ? 'processing...' : 'NON VERIFY'}</Button>{' '}
                    <Button size='small' style={{ fontFamily: 'Times New Roman' }} variant="contained" className='mt-1' color="primary" disabled={DwnlddRqsrDis} onClick={saveimage}>{dwnldRqstCpyPros ? 'processing...' : 'DOWNLOAD REQUEST COPY'}</Button>{' '}
                    <Button size='small' style={{ fontFamily: 'Times New Roman' }} variant="contained" className='mt-1' color="primary" onClick={RefreshBtn}>{refreshPros ? 'processing...' : 'REFRESH'}</Button>
                </div></center>
                <Item hidden={tablehidden}>
                    <TableContainer sx={{ maxHeight: 215 }} className='scrollbarPrime'>
                        <Table className='table table-bordered'>
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell style={{ textAlign: 'center' }}>Sl</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>Description</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>RequestAmount</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }} >Request_Date</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>RequestRemarks</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>RequestBy</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>ApprovalAmount</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>ApprovalDate</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>ApprovalRemarks</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>ApprovalBy</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>1stLevelAmount</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>1stLevelDate</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>1stLevelRemarks</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>1stApprovedBy</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>2ndLevelAmount</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>2ndLevelDate</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>2ndLevelRemarks</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>2nd_ApprovedBy</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AllocatedAmount</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AllocatedDate</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AllocatedRemarks</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AllocatedBY</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>ReleaseAmmount</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>ReleaseDate</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>ReleaseRemarks</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>Release_BY</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AuditedAmmount</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AuditedDate</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AuditedRemarks</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AuditedBY</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {FirstVeriDetails5.map((trns) => (
                                    <TableRow hover key={trns.reqPurpose}>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.serialNumber}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.reqPurpose}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.reqAmount}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }} >{trns.reqDate}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.reqRemarks}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.reqByName}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.approvalAmunt}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.approvalDate}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.appRemarks}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.approvalByName}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.firstLevelAmount}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.firstLevelDate}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.firstRemarks}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.firstLevelVeryBy}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.secondLevelAmount}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.secondLevelDate}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.secondRemarks}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.secondLevelVeryBy}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.allocatedAmount}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.allocatedDate}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.allocatedRemarks}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.allocatedByName}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.releaseAmount}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.release_date}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.releaseRemarks}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.releaseByName}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.audit_amount}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.audit_date}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.audit_remarks}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.audited_by}</StyledTableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Item>
            </div>
        </div>
    )
}

export default FundFristLvlVerification